module.exports = __webpack_public_path__ + "static/media/Avenir-Medium.b18ca932.woff";